<template>
  <div class="">
    <modal
      :show.sync="addmbrModal"
      header-classes="pt-4 pb-0 px-4 bg-primary "
      hide-footer
      footerClasses="hidden"
      class=""
    >
      <h6 slot="header" class="text-xl font-semibold text-white">Add Member</h6>
      <div class="mb-2">
        <b-form-input placeholder="Enter member name" size="sm"></b-form-input>
      </div>
      <div class="mt-2">
        <b-list-group flush class="cust-overflow-y5 h-64">
          <b-list-group-item
            action
            v-for="(member, index) in non_members"
            :key="'non_members-' + index"
            class="cursor-pointer"
          >
            <b-row align-v="center">
              <!-- <b-col md="auto" class="pl-0"> -->
              <!-- TODO: Dynamic user image -->
              <b-avatar variant="info" class="p-3 cust-avatar"></b-avatar>
              <!-- </b-col> -->
              <b-col class="pl-0 pr-0 ml-1">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="ml-2">
                    <h4 class="mb-0 text-sm font-semibold">
                      {{ member.firstname }} {{ member.lastname }}
                    </h4>
                  </div>
                </div>
              </b-col>
              <b-col class="flex justify-end px-0">
                <b-form-checkbox
                  v-model="member.isSelected"
                  name="checkbox-1"
                  :value="true"
                >
                </b-form-checkbox>
              </b-col>
            </b-row>
          </b-list-group-item>
        </b-list-group>
      </div>
    </modal>
    <ViewMemberSidebar
      :isSidebarActive="isViewMemberSidebarActive"
      @closeSidebar="toggleViewMemberSidebar"
    />
    <Add-Member-Sidebar
      :isSidebarActive="openAddMemberSidebar"
      @closeSidebar="toggleAddMemberSidebar"
    />
    <EditChannelName
      :isModalOpen="isEditNameModalOpen"
      @close-modal="toggleEditNameModal"
    />
    <div class="flex justify-between items-center">
      <div class="flex">
        <h2 class="font-semibold">{{ channel.name }}</h2>

        <!-- <div class="" v-if="channel.createdBy._user == userData._id">
          <feather-icon
            icon="Edit3Icon"
            @click="toggleEditNameModal(true)"
            class="cursor-pointer text-gray-400"
            svgClasses="w-4 mx-2"
          ></feather-icon>
        </div> -->
      </div>

      <b-dropdown
        size="lg"
        variant="link"
        toggle-class="text-decoration-none py-2 px-0"
        no-caret
        dropleft
      >
        <template #button-content>
          <feather-icon
            class="cursor-pointer"
            icon="SettingsIcon"
            svgClasses="w-4 h-4 text-black"
          ></feather-icon>
        </template>
        <b-dropdown-item
          @click="toggleEditNameModal(true)"
          v-if="CanCurruntUserAddMember()"
          >Edit Channel</b-dropdown-item
        >
        <b-dropdown-item
          @click="toggleAddMemberSidebar(true)"
          v-if="CanCurruntUserAddMember()"
          class="md:block lg:block hidden"
          >Add Member</b-dropdown-item
        >
        <b-dropdown-item
          @click="addmbrModal = true"
          v-if="CanCurruntUserAddMember()"
          class="block lg:hidden md:hidden"
          >Add Member</b-dropdown-item
        >
        <b-dropdown-item @click="showSwalLeave(channel._id)"
          >Leave</b-dropdown-item
        >
        <b-dropdown-item
          v-if="CanCurruntUserAddMember()"
          @click="showSwalDelete(channel._id)"
          >Delete</b-dropdown-item
        >
      </b-dropdown>
    </div>
    <div class="mb-2 -mt-1">
      <span class="text-sm text-muted font-normal">
        {{ channel.description }}

        <!-- <span class="text-sm text-muted font-normal" >
          browse privately, and other people who use this device won’t see Now
          you can browse privately, and other people who use this device won’t
          seeNow you can browse privately, and other people who use this device
          won’t see
        </span>
        <span
          class="cursor-pointer textblue font-bold"
          @click="readmore = !readmore"
        >
          {{ readmore ? " Read less" : " Read more" }}
        </span> -->
      </span>
    </div>
    <figure class="mt-2">
      <img
        :src="channelImage"
        alt="change-post"
        class="w-full object-cover rounded-lg comm-dp mx-auto"
      />
    </figure>
  </div>
</template>

<script>
import AddMemberSidebar from "./AddMemberSidebar.vue";
import ViewMemberSidebar from "./ViewMemberSidebar";
import { mapState, mapGetters } from "vuex";
import EditChannelName from "./EditChannelName.vue";

export default {
  components: {
    EditChannelName,
    AddMemberSidebar,
    ViewMemberSidebar,
  },
  data() {
    return {
      isEditNameModalOpen: false,
      readmore: false,
      openAddMemberSidebar: false,
      isViewMemberSidebarActive: false,
      addmbrModal: false,
      non_members: [],
    };
  },
  computed: {
    ...mapGetters("channel", {
      members: "visibleMembers",
    }),
    ...mapState("channel", {
      channel: "selectedChannel",
    }),
    ...mapState("auth", {
      userData: "user",
    }),
    channelImage() {
      return `${this.$imageURL}/${this.channel.picture}`;
    },
  },

  methods: {
    AddMember() {
      this.toggleAddMemberSidebar(true);
    },
    toggleAddMemberSidebar(val = false) {
      this.openAddMemberSidebar = val;
    },
    toggleViewMemberSidebar(val = false) {
      this.isViewMemberSidebarActive = val;
    },
    showSwalLeave(channelID) {
      let payload = {
        channelID: channelID,
        // UserID: this.userData._id,
        userLeft: "true",
      };
      this.$swal({
        // title: `Are you sure`,
        text: "Are you sure you want to leave?",
        // buttonsStyling: false,
        showCancelButton: true,
        cancelButtonColor: "",
        confirmButtonClass: "btn btn-primary bg-primary",
        cancelButtonClass: "btn btn-danger",
        confirmButtonText: "OK",
        cancelButtonText: "No",
        icon: "info",
      }).then(async (result) => {
        if (result.value) {
          await this.$store.dispatch("channel/removeMember", payload);
          this.$store.commit("channel/SET_SELECTED_CHANNEL", {});
          this.$store.commit("posts/SET_ALL_POSTS", []);
          await this.$store.dispatch("channel/GetALLChannel");
          this.$swal("Left!", "You have exited this channel.", "success");
        }
      });
    },
    showSwalDelete(channelID) {
      let payload = {
        _id: channelID,
      };
      this.$swal({
        // title: `Are you sure`,
        text: "Are you certain about deleting this?",
        // buttonsStyling: false,
        showCancelButton: true,
        cancelButtonColor: "",
        confirmButtonClass: "btn btn-primary bg-primary",
        cancelButtonClass: "btn btn-danger",
        confirmButtonText: "OK",
        cancelButtonText: "No",
        icon: "info",
      }).then(async (result) => {
        if (result.value) {
          await this.$store.dispatch("channel/DeleteChannel", payload);
          this.$store.commit("channel/SET_SELECTED_CHANNEL", {});
          this.$store.commit("posts/SET_ALL_POSTS", []);
          await this.$store.dispatch("channel/GetALLChannel");
          this.$swal("Deleted!", "You deleted this channel", "success");
        }
      });
    },

    toggleEditNameModal(val = false) {
      this.isEditNameModalOpen = val;
    },
    test() {
      // console.log(this.channel);
    },
    CanCurruntUserAddMember() {
      let User = this.members.find(
        (el) =>
          (el.role == "owner" || el.role == "admin") &&
          el.createdBy._user == this.userData._id
      );
      return !!User;
    },
    async getMembers() {
      const payload = {
        channelID: this.channel._id,
      };
      let loader = this.$loading();
      let data = {};
      try {
        if (
          this.userData.reole !== "admin" ||
          this.userData.reole !== "owner"
        ) {
          // console.log("Unauthorized");
        } else {
          data = await this.$store.dispatch("channel/getNonMembers", payload);
        }
        this.non_members = data.map((x) => ({ ...x, isSelected: false }));
        loader.close();
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },
  },
  mounted() {
    this.test();
    this.getMembers();
    // console.log(this.userData, "******************");
  },
};
</script>
<style>
@media (max-width: 640px) {
  .modal-dialog {
    margin: 1rem !important;
  }
}
</style>
